import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {TextInput} from 'react-native';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';

export const ContentContainer = styled.View`
  padding: ${RFValue(12)}px ${RFValue(24)}px;
  padding-bottom: 0px;
`;

export const Handle = styled.View`
  width: ${RFValue(40)}px;
  height: ${RFValue(4)}px;
  border-radius: ${RFValue(2)}px;
  background-color: ${({theme}) => theme.colors.border};
  align-self: center;
  margin-bottom: ${RFValue(20)}px;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(4)}px;
`;

export const Subtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text};
  margin-bottom: ${RFValue(20)}px;
`;

export const LitrosInputContainer = styled.View`
  align-items: center;
  margin-top: ${RFValue(8)}px;
  margin-bottom: ${RFValue(8)}px;
`;

export const LitrosRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(16)}px;
`;

export const LitrosButton = styled.TouchableOpacity<{disabled?: boolean}>`
  width: ${RFValue(44)}px;
  height: ${RFValue(44)}px;
  border-radius: ${RFValue(22)}px;
  border-width: 2px;
  border-color: ${({theme, disabled}) =>
    disabled ? theme.colors.border : theme.colors.red};
  align-items: center;
  justify-content: center;
  opacity: ${({disabled}) => (disabled ? 0.35 : 1)};
`;

export const LitrosButtonIcon = styled(Feather)`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.red};
`;

export const LitrosInput = styled(TextInput)`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(36)}px;
  color: ${({theme}) => theme.colors.title};
  min-width: ${RFValue(80)}px;
  text-align: center;
  padding: ${RFValue(8)}px;
  border-bottom-width: 2px;
  border-bottom-color: ${({theme}) => theme.colors.border};
`;

export const LitrosUnit = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text};
  margin-top: ${RFValue(4)}px;
`;

export const PricePreview = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(20)}px;
`;

export const ButtonsContainer = styled.View`
  gap: ${RFValue(10)}px;
  padding-top: ${RFValue(10)}px;
`;

// ─── Info trigger button ───────────────────────────────────────────────────────

export const InfoTriggerButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  background-color: ${({theme}) => theme.colors.background};
  padding: ${RFValue(12)}px ${RFValue(0)}px;
  margin-top: ${RFValue(16)}px;
  gap: ${RFValue(12)}px;
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
`;

export const InfoTriggerLeft = styled.View`
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(10)}px;
`;

export const InfoTriggerIconCircle = styled.View`
  width: ${RFValue(34)}px;
  height: ${RFValue(34)}px;
  border-radius: ${RFValue(17)}px;
  background-color: rgba(255, 59, 48, 0.12);
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const InfoTriggerIcon = styled(Feather)`
  font-size: ${RFValue(15)}px;
  color: ${({theme}) => theme.colors.red};
`;

export const InfoTriggerTextBlock = styled.View`
  flex: 1;
`;

export const InfoTriggerLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const InfoTriggerSub = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
  margin-top: ${RFValue(1)}px;
`;

export const InfoTriggerText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text};
  flex: 1;
`;

export const InfoTriggerChevron = styled(Feather)`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.placeholder};
`;

// ─── Info sheet ───────────────────────────────────────────────────────────────

export const InfoSheetContent = styled.View`
  padding: ${RFValue(4)}px ${RFValue(20)}px ${RFValue(8)}px;
`;

export const InfoSheetIconCircle = styled.View`
  width: ${RFValue(52)}px;
  height: ${RFValue(52)}px;
  border-radius: ${RFValue(26)}px;
  background-color: ${({theme}) => theme.colors.shape};
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-bottom: ${RFValue(10)}px;
`;

export const InfoSheetMainIcon = styled(FontAwesome5)`
  font-size: ${RFValue(28)}px;
  color: ${({theme}) => theme.colors.red};
`;

export const InfoSheetTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(17)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(6)}px;
`;

export const InfoSheetDesc = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text};
  line-height: ${RFValue(19)}px;
  margin-bottom: ${RFValue(20)}px;
`;

export const InfoStepCard = styled.View`
  flex-direction: row;
  align-items: flex-start;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(12)}px;
  margin-bottom: ${RFValue(20)}px;
  gap: ${RFValue(10)}px;
`;

export const InfoStepIconBox = styled.View<{accent: string}>`
  width: ${RFValue(36)}px;
  height: ${RFValue(36)}px;
  border-radius: ${RFValue(18)}px;
  background-color: ${({accent}) => accent};
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const InfoStepIcon = styled(Feather)<{accent: string}>`
  font-size: ${RFValue(18)}px;
  color: ${({accent}) => accent};
`;

export const InfoStepBody = styled.View`
  flex: 1;
`;

export const InfoStepCardTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(3)}px;
`;

export const InfoStepCardText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  line-height: ${RFValue(17)}px;
`;

export const InfoExampleBox = styled.View`
  flex-direction: row;
  background-color: ${({theme}) => theme.colors.price_card};
  border-radius: ${RFValue(10)}px;
  overflow: hidden;
  margin-top: ${RFValue(4)}px;
  margin-bottom: ${RFValue(14)}px;
`;

export const InfoExampleAccent = styled.View`
  width: ${RFValue(3)}px;
  background-color: ${({theme}) => theme.colors.red};
`;

export const InfoExampleInner = styled.View`
  flex: 1;
  padding: ${RFValue(14)}px;
`;

export const InfoExampleLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.red};
  letter-spacing: 0.8px;
  margin-bottom: ${RFValue(6)}px;
`;

export const InfoExampleText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text};
  line-height: ${RFValue(20)}px;
`;

export const InfoExampleBold = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
`;
